import { inject, Component, HostListener, Inject, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss']
})
export class DialogComponent {

  public data = inject(MAT_DIALOG_DATA);

  private delete = new BehaviorSubject<boolean>(false);
  public deleteObs = this.delete.asObservable();

  isLoading;
  @ViewChild('deleteTemplate', { static: true }) deleteTemplate: TemplateRef<any>;

  @HostListener('keydown.esc')
  public onEsc() {
  }

  ngOnInit() {
    if (this.data.type === 'confirmDelete') {
      this.data.content = this.deleteTemplate;
    }
  }

  deleteComment(): void {
    this.delete.next(true);
  }

  cancelDelete(): void {
  }

}
